import { NavLink, useParams } from 'react-router-dom'

import { buildShareUrl, parseMarkdown, imageWidth, ServiceEnum } from 'utils'
import { Container } from 'components/container'
import { Layout } from 'components/layout'
import { IconFacebook } from 'components/icons/facebook'
import { IconTelegram } from 'components/icons/telegram'
import { useDataContext } from 'context/data-context'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { MaleIcon } from './male-icon'
import {
  Dl,
  Dt,
  Dd,
  Profile,
  PhotoContainer,
  Title,
  Social,
  SubmitInfo,
  ImageWrapper,
  ProfileWrapper,
  ArticleFeatured,
  Item,
} from './styled'

const shareOptions = [
  { component: IconFacebook, service: 'facebook' },
  { component: IconWhatsapp, service: 'whatsapp' },
  { component: IconTelegram, service: 'telegram' },
]

export const Detail = () => {
  const params = useParams()
  const { people, texts, translate } = useDataContext()
  const person = people.find((p) => p.id.toString() === params.id)

  if (!person) {
    return (
      <Container>
        <p>Not found</p>
      </Container>
    )
  }

  return (
    <Layout>
      <Container>
        <ProfileWrapper>
          <Profile>
            <PhotoContainer>
              {person.Photo_URL ? (
                <ImageWrapper>
                  <img src={imageWidth(person.Photo_URL, 460)} alt="" />
                </ImageWrapper>
              ) : (
                <MaleIcon />
              )}
            </PhotoContainer>
            <Title>{person.Name}</Title>
            <Dl>
              <Item>
                <Dt>{texts.Occupation ?? 'Occupation'}: </Dt>
                <Dd>{person.Occupation}</Dd>
              </Item>
              <Item>
                <Dt>{texts.Punishment ?? 'Punishment'}: </Dt>
                <Dd>{person.Punishment}</Dd>
              </Item>
              <Item>
                <Dt>{texts.Age ?? 'Age'}: </Dt>
                <Dd>{person.Age}</Dd>
              </Item>
              <Item>
                <Dt>{texts.Charge ?? 'Charge'}: </Dt>
                <Dd>{person.Charge}</Dd>
              </Item>
            </Dl>
            <Social>
              {translate('Share this person')}
              <ul>
                {shareOptions.map((s) => (
                  <li key={s.service}>
                    <a
                      href={buildShareUrl(s.service as ServiceEnum)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <s.component />
                    </a>
                  </li>
                ))}
              </ul>
            </Social>
            <SubmitInfo className="underline">
              <div>
                <NavLink to="/send-data">
                  {translate('Do you have more info?')}
                </NavLink>
              </div>
            </SubmitInfo>
          </Profile>
        </ProfileWrapper>

        {!!person.Description && (
          <ArticleFeatured>{parseMarkdown(person.Description)}</ArticleFeatured>
        )}
      </Container>
    </Layout>
  )
}
